// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { ButtonGroup as MuiButtonGroup, styled } from "@mui/material";

export const ButtonGroup = styled(MuiButtonGroup)`
    margin-right: -14px;

    button:first-of-type, .MuiButtonGroup-firstButton {
        border-radius: 0 .25rem .25rem 0;
    }
`;